import React, { useEffect } from "react";
import WebChatApp from "./WebChatApp";
import { RouteComponentProps } from "react-router-dom";
import qs from "query-string";
import authStore from "./store/AuthStore";
import axios from "axios";
import mobile from "is-mobile";

interface Params {
    scenarioId: string;
}

const App: React.FC<RouteComponentProps<Params>> = ({ match, location }) => {
    useEffect(() => {
        authStore.getLoginUser().catch((e) => {
            if (e.response && e.response.status !== 401) {
                console.error(e);
            } else if (e.response && e.response.status === 401) {
                if (!mobile()) {
                    window.location.href = `${process.env.REACT_APP_API_HOST}/auth/login?client_redirect_uri=${document.URL}&disabled_signed_user=true`;
                }
            }
        });

        axios.get('https://chat-mgt.hanwhaocean.com/cms/auth/profile').catch(e => {
            if (e.response && e.response.status === 401) {
                if (!mobile()) {
                    window.location.href = `https://chat-mgt.hanwhaocean.com/cms/auth/login?client_redirect_uri=${document.URL}&disabled_signed_user=true`;
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const queryStringParams = qs.parse(location.search);
    return <WebChatApp scenarioIdOrAlias={"RM"} isTest={queryStringParams.channel === "test"} />;
};

export default App;
